import Endpoint from "../../services/api/endpoint";
import { IStockLine } from "../../utils/types/models";
import { createEntityReducer } from "./entityReducer";

export default createEntityReducer<IStockLine>(Endpoint.ProductStock, Endpoint.ProductStockList);